import { render, staticRenderFns } from "./OpeningAnimation.vue?vue&type=template&id=639b0632&scoped=true"
import script from "./OpeningAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./OpeningAnimation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OpeningAnimation.vue?vue&type=style&index=0&id=639b0632&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b0632",
  null
  
)

export default component.exports